import { FocusRequirementWithDetails, PlanRequirementDecision } from '@shared/schema';

export type PlanRequirementDecisionLookup = Map<number, Map<number, PlanRequirementDecision>>;

export function buildPlanRequirementDecisionLookup(
  decisions: PlanRequirementDecision[] | undefined,
): PlanRequirementDecisionLookup {
  const lookup: PlanRequirementDecisionLookup = new Map();
  if (!decisions || decisions.length === 0) {
    return lookup;
  }
  decisions.forEach((decision) => {
    const focusId = decision.APFocusId;
    const requirementId = decision.APRequirementId;
    if (!lookup.has(focusId)) {
      lookup.set(focusId, new Map());
    }
    lookup.get(focusId)!.set(requirementId, decision);
  });
  return lookup;
}

export function filterRequirementsByDecisions(
  requirements: FocusRequirementWithDetails[],
  decisionLookup: PlanRequirementDecisionLookup,
): FocusRequirementWithDetails[] {
  if (!requirements || requirements.length === 0) {
    return [];
  }
  const isEnabled = (decision: PlanRequirementDecision | undefined): boolean => {
    if (!decision) return false;
    const rawValue = decision.Enabled as unknown;
    if (typeof rawValue === 'boolean') return rawValue;
    if (typeof rawValue === 'number') return rawValue === 1;
    if (typeof rawValue === 'string') {
      const normalized = rawValue.trim().toLowerCase();
      return normalized === 'true' || normalized === '1';
    }
    return false;
  };
  return requirements
    .map((focusRequirement) => {
      const focusDecisions = decisionLookup.get(focusRequirement.APFocusId);
      if (!focusDecisions || focusDecisions.size === 0) {
        return {
          ...focusRequirement,
          RequirementTypes: [],
        };
      }
      const filteredTypes = focusRequirement.RequirementTypes.map((typeGroup) => {
        const filteredReqs = typeGroup.requirements.filter((requirement) => {
          const decision = focusDecisions.get(requirement.APRequirementId);
          return isEnabled(decision);
        });
        return {
          ...typeGroup,
          requirements: filteredReqs,
        };
      }).filter((typeGroup) => typeGroup.requirements.length > 0);

      return {
        ...focusRequirement,
        RequirementTypes: filteredTypes,
      };
    })
    .filter((focusRequirement) => focusRequirement.RequirementTypes.length > 0);
}
